import * as React from 'react'
import onClickOutside from 'react-onclickoutside'
import styled from 'styled-components'
import { theme } from 'utils'

type PropsType = {
  children: React.ReactNode
  onClickOutside: () => void
}

const PopoverContainer = styled.div`
  border-radius: ${theme('buttonBorderRadius')};
  box-shadow: 0 10px 60px -10px rgba(0, 0, 0, 0.25), 0 8px 16px rgba(0, 0, 0, 0.1);
`

class Content extends React.Component<PropsType> {
  handleClickOutside = () => {
    this.props.onClickOutside()
  }

  render() {
    const { children } = this.props

    return <PopoverContainer>{children}</PopoverContainer>
  }
}

export default onClickOutside(Content)
